import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeCreateGeneralAttestationMutation as useDeCreateGeneralAttestationMutationType } from "@/modules/patients/detail/general-attestation/de/services/__generated__/useDeCreateGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeCreateGeneralAttestationMutation($input: De_createGeneralAttestationInput!) {
    de_createGeneralAttestation(input: $input) {
      de_GeneralAttestation {
        id
        ...deGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeCreateGeneralAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeCreateGeneralAttestationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreateGeneralAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreateGeneralAttestationMutation }
